import React from 'react';
import { Switch, Tooltip } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import DeleteButton from '@src/components/Common/DeleteButton';

/**
 * One document under the shared column header. The row opens it; the switch and
 * the delete act on it in place, so both stop the click from reaching the row.
 */
const DocumentRow = ({
    record,
    resource,
    isAdmin,
    updating,
    onToggleEnabled,
    refetch,
}: {
    record: any;
    resource: string;
    isAdmin: boolean;
    updating: boolean;
    onToggleEnabled: (record: any) => void;
    refetch: () => void;
}) => {
    const history = useHistory();
    const open = () => history.push(`/${resource}/${record.id}/edit/`);

    return (
        <div
            className="doc-row"
            role="button"
            tabIndex={0}
            aria-label={`Open ${record.filename}`}
            onClick={open}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    open();
                }
            }}
        >
            <Tooltip placement="topLeft" title={record.filename}>
                <div className="doc-name">
                    <FileTextOutlined className="doc-name__ico" aria-hidden="true" />
                    <span className="doc-name__text">{record.filename || '—'}</span>
                </div>
            </Tooltip>

            <div className="doc-cell doc-cell--size" data-label="Size">
                {typeof record.num_chars === 'number' ? `${record.num_chars.toLocaleString()} chars` : '—'}
            </div>

            <Tooltip placement="topLeft" title={record.preview}>
                <div className="doc-cell doc-preview" data-label="Preview">{record.preview || '—'}</div>
            </Tooltip>

            <Tooltip placement="topLeft" title={record.service?.name}>
                <div className="doc-cell" data-label="Service">{record.service?.name || '—'}</div>
            </Tooltip>

            <div
                className="doc-actions"
                role="presentation"
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
            >
                {isAdmin && (
                    <>
                        <Switch
                            className="doc-enabled"
                            checked={record.enabled}
                            loading={updating}
                            onChange={() => onToggleEnabled(record)}
                            checkedChildren="Enabled"
                            unCheckedChildren="Disabled"
                        />
                        <DeleteButton
                            size="small"
                            title="Document"
                            resource={resource}
                            record={record}
                            refetch={refetch}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default DocumentRow;
